import React from 'react';

import { useIsAssemblyBrandEnabled } from 'src/hooks/useIsAssemblyBrandEnabled';
import { CopilotAdminAuthBackground } from 'src/theme/colors';

const ONBOARDING_RESET_ID = 'onboarding-reset';

const onboardingCss = [
  '*{margin:0;padding:0;box-sizing:inherit}',
  'html{height:100%;width:100%;box-sizing:border-box;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}',
  'body{height:100%;width:100%;font-size:13px;line-height:1.2;margin:0}',
  '#app{height:100%;width:100%}',
];

export const OnboardingPageLayout: React.FC = ({ children }) => {
  const { isAssemblyBrandEnabled } = useIsAssemblyBrandEnabled();

  // Inject static CSS resets — same pattern as AppShell
  React.useLayoutEffect(() => {
    if (document.getElementById(ONBOARDING_RESET_ID)) return;
    const style = document.createElement('style');
    style.id = ONBOARDING_RESET_ID;
    style.textContent = onboardingCss.join('');
    document.head.appendChild(style);
  }, []);

  // Apply dynamic body background (desktop only — matches original sm breakpoint)
  React.useLayoutEffect(() => {
    if (typeof window.matchMedia !== 'function') {
      return;
    }
    const mq = window.matchMedia('(min-width: 600px)');
    const update = () => {
      document.body.style.backgroundColor =
        mq.matches && !isAssemblyBrandEnabled ? CopilotAdminAuthBackground : '';
    };
    update();
    mq.addEventListener('change', update);
    return () => {
      mq.removeEventListener('change', update);
      document.body.style.backgroundColor = '';
    };
  }, [isAssemblyBrandEnabled]);

  return (
    <div className="h-full flex flex-col">
      <div className="w-full m-auto">{children}</div>
    </div>
  );
};
